import React from 'react';
import styled from 'styled-components';
import {COLORS, SIZES} from '@fupa/fupa-uikit';
import {FlexContainer, StyledTypography} from 'app/styles/content';

const Container = styled(FlexContainer)`
  flex-direction: column;
  padding-top: ${SIZES['10']};
  padding-bottom: ${SIZES['16']};
  align-items: center;
  border-top: ${props => (props.index < 4 ? '1px solid ' + COLORS.lighterGrey : 'none')};
  border-right: ${props => (props.index % 3 === 0 ? 'none' : '1px solid ' + COLORS.lighterGrey)};
  border-bottom: 1px solid ${COLORS.lighterGrey};
`;

const MetricTile = ({value, label, index}) => {
  return (
    <Container index={index + 1}>
      <StyledTypography variant='headline2' lineHeight={36} textAlign='center'>
        {value}
      </StyledTypography>
      <StyledTypography variant='caption3' lineHeight={16} textAlign='center'>
        {label}
      </StyledTypography>
    </Container>
  );
};

export default MetricTile;
